import React from 'react';
import PostCreatedTime from './PostCreatedTime';
import "./postHeader.scss";

export const UserLinkAndPostTime = ({post, pageName }) => {
  const username = post.username || (`${post.provider} User`);

  return (
    <React.Fragment>
      <span className="user">
        {
          post.url
            ? <a className="subdued-link" target="_blank" title={"View original post."} href={post.url}>{username}</a>
            : <span>{username}</span>
        }
      </span>
      <span>{pageName ? <React.Fragment><span className="arrow">&nbsp;▶</span> {pageName} </React.Fragment>: ""}</span>
      <span className="content-spacer-left">
        {post.isUnpublished ? null : <PostCreatedTime date={post.createdTime}/>}
      </span>
    </React.Fragment>
  )
};
